/**
 * Supplementary study materials: download-only files a cohort's mentor shares
 * in a module. Files move straight between the browser and cloud storage
 * through signed URLs; the API only signs and records them.
 */

import api from "../../api";
import { uploadFile } from "../ContentBank/contentBankApi";

const BASE = "api/study-materials";

/** A cohort module ("template", the batch shares it) or a 1:1 student's own card ("topic", theirs alone). */
const owner = (moduleId, kind) => `${BASE}/${kind === "topic" ? "topics" : "modules"}/${moduleId}/`;

export { errorMessage } from "../ContentBank/contentBankApi";

export const listMaterials = async (moduleId, kind = "template") =>
  (await api.get(owner(moduleId, kind))).data;

export const startUpload = async (moduleId, files, kind = "template") =>
  (await api.post(`${owner(moduleId, kind)}uploads/`, { files })).data;

export const completeUpload = async (moduleId, batch, files, kind = "template") =>
  (await api.post(`${owner(moduleId, kind)}complete/`, { batch, files })).data;

/** Signed download URLs: pass ids, or "all". */
export const getDownloadUrls = async (moduleId, ids, kind = "template") =>
  (await api.post(`${owner(moduleId, kind)}download-urls/`, ids === "all" ? { all: true } : { ids })).data.files;

export const deleteMaterials = async (moduleId, ids, kind = "template") =>
  (await api.post(`${owner(moduleId, kind)}delete/`, { ids })).data;

export const restoreMaterials = async (moduleId, ids, kind = "template") =>
  (await api.post(`${owner(moduleId, kind)}restore/`, { ids })).data;

export const renameFolder = async (moduleId, from, to, kind = "template") =>
  (await api.post(`${owner(moduleId, kind)}rename-folder/`, { from, to })).data;

export const renameFile = async (fileId, path) =>
  (await api.patch(`${BASE}/files/${fileId}/`, { path })).data;

export { uploadFile };
